import {useEffect, useRef, useState, type RefObject} from 'react';
import {isCasinoPage} from './IsCasinoPage';

const HEADER_HEIGHT = 70;

const stickyTop = (innerHeight: number, viewportHeight: number, bottomOffset: number): string => {
    const top = Math.min(HEADER_HEIGHT, viewportHeight - bottomOffset - innerHeight);

    return `${top}px`;
};

export const useAsideStickyTop = (
    enabled: boolean,
    withCasinoOffset = false
): {ref: RefObject<HTMLDivElement>, top: string} => {
    const bottomOffset = withCasinoOffset && isCasinoPage() ? HEADER_HEIGHT : 0;
    const ref = useRef<HTMLDivElement>(null);
    const [top, setTop] = useState('0px');

    useEffect(() => {
        if (!enabled) {
            return () => {
                setTop('0px');
            };
        }

        const updatePosition = (): void => {
            const innerHeight = ref.current?.offsetHeight ?? 0;

            setTop(stickyTop(innerHeight, document.documentElement.clientHeight, bottomOffset));
        };

        const resizeObserver = new ResizeObserver(updatePosition);

        if (ref.current) {
            resizeObserver.observe(ref.current);
        }

        window.addEventListener('resize', updatePosition);
        updatePosition();

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', updatePosition);
        };
    }, [bottomOffset, enabled]);

    return {ref, top};
};
